import { render, staticRenderFns } from "./KnittingReport.vue?vue&type=template&id=c97d87f8&scoped=true"
import script from "./KnittingReport.vue?vue&type=script&lang=js"
export * from "./KnittingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97d87f8",
  null
  
)

export default component.exports